import parserChainTest from './parser_chain_test';
import parserCoreTest from './parser_core_test';
import parserCoreDefaultTest from './parser_core_default_test';
import parserExtensionTest from './parser_extensions_test';
import parserStreamTest from './parser_stream_test';
import parserResponseTest from './response_test';
import flowBundleTest from './flow-bundle-test';
import charsBundleTest from './chars-bundle-test';
import numberBundleTest from './number-bundle-test';
import fLayerTest from './f-layer-test';
import tupleParserTest from './tuple-parser-test';

export default {
    parserChainTest,
    parserCoreTest,
    parserCoreDefaultTest,
    parserExtensionTest,
    parserStreamTest,
    parserResponseTest,
    flowBundleTest,
    charsBundleTest,
    numberBundleTest,
    fLayerTest,
    tupleParserTest
}